const mutations = {
  setIdKomplain: (state, payload) => {
    console.log(payload);
    state.idKomplain = payload
  },
  setListKomplain: (state, payload) => {
    state.listKomplain = payload
  },
  updateListKomplain: (state, payload) => {
    let data = state.listKomplain.actual_data
    data.push(...payload.actual_data)
  },
  resetListKomplain: (state) => {
    state.listKomplain = {
      actual_data: [],
      total: 0,
      count_data: 0
    }
  },
  setDetailKomplain: (state, payload) => {
    state.detailKomplain = payload
  },
  setListAkunRefund: (state, payload) => {
    state.listAkunRefund = payload
  },
  setScrollState: (state, payload) => {
    state.scrollState = payload
  },
  resetScrollState: (state) => {
    state.scrollState = 0
  },
  setNeedReload: (state, payload) => {
    state.needReload = payload
  },
  setListTransaksi: (state, payload) => {
    console.log(payload);
    state.listTransaksi = payload
  },
  setListTransaksiSearch: (state, payload) => {
    state.listTransaksiSearch = payload
  },
  setListTransaksiSnap: (state, payload) => {
    state.listTransaksiSnap = payload
  },
  updateListTransaksiSnap: (state, payload) => {
    state.listTransaksiSearch.push(...payload)
  },
  setCount: (state, payload) => {
    state.countData = payload
  }
};

export default mutations;
